import { gql } from '@apollo/client';

export const GET_FACULTY_TYPES = gql`
  query GetFacultyTypes($path: String!, $template: String!) {
    search(
      where: {
        AND: [
          { name: "_path", value: $path, operator: CONTAINS }
          { name: "_templates", value: $template, operator: EQ }
        ]
      }
    ) {
      results {
        id(format: "D")
        Description: field(name: "Description") {
          value
        }
      }
    }
  }
`;

export const GET_ALL_FACULTY = gql`
  query GetAllFaculty(
    $path: String!
    $template: String!
    $pageSize: Int!
    $after: String
  ) {
    search(
      first: $pageSize
      after: $after
      where: {
        AND: [
          { name: "_path", value: $path, operator: CONTAINS }
          { name: "_templates", value: $template, operator: EQ }
        ]
      }
      orderBy: { name: "Name", direction: ASC }
    ) {
      total
      pageInfo {
        endCursor
        hasNext
      }
      results {
        id
        path
        Name: field(name: "Name") {
          value
        }
        Title: field(name: "Title") {
          value
        }
        Type: field(name: "Type") {
          jsonValue
        }
        Email: field(name: "Email") {
          value
        }
        Gender: field(name: "Gender") {
          value
        }
        Phone: field(name: "Phone") {
          value
        }
        Photo: field(name: "Photo") {
          jsonValue
        }
      }
    }
  }
`;

export const GET_FILTERED_FACULTY = gql`
  query GetFilteredFaculty(
    $path: String!
    $filterValue: String!
    $pageSize: Int!
    $after: String
  ) {
    search(
      first: $pageSize
      after: $after
      where: {
        AND: [
          { name: "_path", value: $path, operator: CONTAINS }
          { name: "Type", value: $filterValue, operator: CONTAINS }
        ]
      }
      orderBy: { name: "Name", direction: ASC }
    ) {
      total
      pageInfo {
        endCursor
        hasNext
      }
      results {
        id
        path
        Name: field(name: "Name") {
          value
        }
        Title: field(name: "Title") {
          value
        }
        Type: field(name: "Type") {
          jsonValue
        }
        Email: field(name: "Email") {
          value
        }
        Gender: field(name: "Gender") {
          value
        }
        Phone: field(name: "Phone") {
          value
        }
        Photo: field(name: "Photo") {
          jsonValue
        }
      }
    }
  }
`;
